import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { OrganizationService, OrganizationModel } from './organization.service';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { CreateOrgVdcWizard } from '../org-vdc-wizard/create-org-vdc.wizard';
import { AuthService } from '../../../../auth/auth.service';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
  selector: 'organization-container',
  providers: [
    TranslateService, OrganizationService, OrganizationModel
  ],
  styles: [require('./organization.scss')],
  template: require('./organization.html')
})
export default class Organization {
  private jsonData: any;
  private loaded: boolean = false;
  private openWizard: boolean = false;
  private subscription: Subscription;
  private isEditOrgVisible: boolean = false;
  private isDeleteDisableMessage: boolean = false;
  private isDeleteOrgPopupVisible: boolean = false;
  private isAddVdcPopupVisible: boolean = false;
  private isOrgVdcEdit: boolean = false;
  private orgVdcId: string = '';
  private orgId: string = '';
  private isCreateOrgVdcWizardVisible: boolean = false;
  private orgSSOURL: string;
  private hasChildren: boolean;
  private orgDisplayName: string;
  private rsService: RefreshSharedService;
  private refreshSubscription: Subscription;
  private currentClassName: string = '';
  private disableEditAndDeleteOrgButton = false;

  constructor(public organizationService: OrganizationService,
              private translateService: TranslateService,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private organizationModel: OrganizationModel, 
              public authService: AuthService,
              private rss: RefreshSharedService) {
    translateService.use(GlobalVariables.LOCALE);
    this.rsService = rss;
    this.currentClassName = 'Organization'; 
  }


  ngOnInit() {
      this.refreshSubscription = this.rsService.getRefreshParam()
      .subscribe (
        item => {
          this.handleEmittedValues(item);
      });

      this.activatedRoute.params.forEach((params: Params) => {
          this.orgId = params['id1'];
          this.rsService.setParam({
              'loadedComponent': this.currentClassName,
              'detailPageIDName': this.orgId,
              'shouldReloadInventoryTree': true
          })
          this.getOrgDetails(this.orgId);
      });

      let roles = this.authService.loggedInUserInfo.roles;
      roles.forEach((role) => {
        if ( role === 'VI Administrator' ) {
          this.disableEditAndDeleteOrgButton = true;
        }
      });
  }

   handleEmittedValues(item) {
      if (item.loadedComponent === this.currentClassName && this.orgId === item.detailPageIDName) {
          this.jsonData = [];
          this.getOrgDetails(item.detailPageIDName);
      }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.rsService.resetParam();
    if (this.refreshSubscription) {
      this.refreshSubscription.unsubscribe();
    }
  }

  onEditOrganization() {
    this.isEditOrgVisible = true;
  };

  onDeleteOrganization() {
    if (this.hasChildren) {
      this.isDeleteDisableMessage = true;
    } else {
      this.isDeleteOrgPopupVisible = true;
    }
  };

  onAddVdc() {
    this.isOrgVdcEdit = false;
    this.orgVdcId = '';
    this.isCreateOrgVdcWizardVisible = true;
  };

  convertToHex(str) {
	    let hex = '';
	    for(let i=0;i<str.length;i++) {
	        hex += ''+str.charCodeAt(i).toString(16);
	    }
	    return hex;
	}

  onMangeInVcd = ($event) => {
    if ( this.jsonData.vcd && this.jsonData.vcd.href) {
       let href = this.jsonData.vcd.href;
       let prefix = href.substring(0, href.indexOf("/api"));
       let orgName = this.jsonData.vcd.name
       let uiEndpoint = prefix + "/compute/cloud/org/" + orgName.toLowerCase() + "/";
       let hexEncodedUrl = this.convertToHex(uiEndpoint);
       let redirecttUrl = "redirectUrl_"+orgName;
       let cookieToSet = redirecttUrl+"=" + hexEncodedUrl
       document.cookie = cookieToSet + ";path=/";
       console.log("Setting cookie " + cookieToSet + ";path=/");
       window.open(uiEndpoint,'_blank');
    } else {
       console.error("Unable to set redirect Cookie");
    }
  };

  onEditVdc(){
    this.isOrgVdcEdit = true;
    this.openWizard = true;
  };

  onEditOrganizationClose = ($event) => {
    if ($event && $event.value) {
      this.isEditOrgVisible = false;
    }
  };

  onDeleteOrganizationClose = ($event) => {
    if ($event && $event.value) {
      this.isDeleteOrgPopupVisible = false;
    }
  };

  setOrganization(res) {
    this.jsonData = res;
    this.loaded = true;
    this.setOrgDisplayName(this.jsonData.orgName, this.jsonData.orgFullName);
    this.setSSOUrl(this.jsonData.orgName);
    this.hasChildren = this.jsonData.hasChildren;
  }

  getOrgDetails(id) {
    this.loaded = false;
    this.organizationService.getOrganizationDetails(id).subscribe(
      results => {
        this.setOrganization(results);
      },
      error => {
        this.logError(error, 'get org details')
        this.loaded = true
      },
      () => {
        this.logOperationCompleted('get org details')
        this.loaded = true;
      }
    );
  }
  
  orgVdcWizardStatusChange(event) {
    this.isCreateOrgVdcWizardVisible = event;
  }

  logError(error, origin: String = '') {
    console.error('Error: ', error, (origin !== '') ? ' Error from ' + origin : '');
  }

  logOperationCompleted(msg: string) {
    console.log('Operation Completed: ', msg);
  }

  setSSOUrl(orgName: String) {
    if (!orgName || orgName === '') {
      return;
    }
    let url = document.createElement('a');
    url.href = window.location.href;
    let ssourl = url.protocol + '//' + url.host + '/compute/cloud/org/' + orgName.toLowerCase() + '/#/orgUserHome?';
    this.orgSSOURL = ssourl;
  }

  setOrgDisplayName(orgName: string, orgFullName: string) {
    this.orgDisplayName = orgFullName ? orgFullName : orgName;
  }

};



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/organization/organization.component.ts